export const AUTH = {
    forceAttempt: 'invalidAttempt',
    token: 'apptoken',
    tokenExpiration: 'appexpire',
    username: 'username',
    userId: 'userId',
    userRole: 'userRole',
    userFullName: 'userFullName'
}


// WEBPACK FOOTER //
// ./src/app/contants/AUTH.ts